import { Component, OnDestroy, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { PAQRCodeSelectRequest } from "../student-portal-app-reg/shared/PAQRCodeSelectRequest";
import { DataService_Staff_PortalAppReg } from "./shared/data.service";
import { PersonRegisteredUsersRequest } from "./shared/person-registered-users-request";
import { RegPersonToggleRequest } from "./shared/reg-person-toggle-request";

@Component({
	selector: "app-staff-portal-app-reg",
	templateUrl: "./staff-portal-app-reg.component.html",
	styleUrls: ["./staff-portal-app-reg.component.css"],
})
export class StaffPortalAppRegComponent implements OnInit, OnDestroy {
	constructor(
		private personselectorService: PersonSelectorService,
		private dataService: DataService_Staff_PortalAppReg,
		private confirmationService: ConfirmationService
	) {}

	ngOnDestroy(): void {
		this.subscriptionPersonSelect.unsubscribe();
	}

	ngOnInit(): void {
		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.ErrorMessage = "";

			// this.loadQRCode();
			this.loadEmail();
			this.loadRegisteredUsers();
		});

		if (this.SelectedPerson != undefined) {
			// this.loadQRCode();
			this.loadEmail();
			this.loadRegisteredUsers();
		}
	}

	//////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////

	subscriptionPersonSelect: any;
	SelectedPerson: any;

	ShowQRCode: boolean = false;
	QRCode: string = "";
	QRLoading: boolean = false;

	Email: string = "";
	EmailLoading: boolean = false;
	LockEmail: boolean = false;
	SyncWithCAASS: boolean = false;

	HasUserAccount: boolean = false;

	Proccessing: boolean = false;
	ErrorMessage: string = "";

	LoadingRegUser: boolean = false;
	lstRegUser: any = [];
	SelectedRegUser: any;

	lstLanguageDesc: any = [];
	lstRegPersonActiveDesc: any = [];

	reguserpagerows: any = 10;
	reguserpagefirst: any = 0;

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////

	loadQRCode() {
		this.QRCode = "";

		if (this.SelectedPerson == undefined || this.SelectedPerson.PersonID == undefined || this.SelectedPerson.PersonID <= 0) {
			return;
		}

		this.ShowQRCode = true;
		this.QRLoading = true;

		var parms: PAQRCodeSelectRequest = {
			AppTypeID: 3, //Staff App
			PersonID: this.SelectedPerson.PersonID,
			Email: this.Email,
			EmailLocked: this.LockEmail,
			UsePrimaryDomain: this.SyncWithCAASS,
		};

		var result = this.dataService.PortalAppQRCodeSelect(parms);
		result.subscribe(
			(response: any) => {
				this.QRCode = response.str;

				this.QRLoading = false;
			},
			(error) => {
				this.QRLoading = false;
			}
		);
	}

	loadEmail() {
		this.Email = "";
		this.HasUserAccount = false;

		if (this.SelectedPerson == undefined || this.SelectedPerson.PersonID == undefined || this.SelectedPerson.PersonID <= 0) {
			return;
		}

		this.EmailLoading = true;

		var result = this.dataService.PersonPortalRegInfoSelect(this.SelectedPerson.PersonID);
		result.subscribe(
			(response: any) => {
				this.Email = response.Email;
				this.HasUserAccount = response.HasUserAccount;

				this.EmailLoading = false;
			},
			(error) => {
				this.EmailLoading = false;
			}
		);
	}

	loadRegisteredUsers() {
		this.lstRegUser = [];

		if (this.SelectedPerson == undefined || this.SelectedPerson.PersonID == undefined || this.SelectedPerson.PersonID <= 0) {
			return;
		}

		var parms: PersonRegisteredUsersRequest = {
			Token: "", // Filled in by server
			PersonID: this.SelectedPerson.PersonID,
			Domain: "", // Filled in by server
			RegAppTypeID: 3, // Staff App
		};

		this.LoadingRegUser = true;

		var result = this.dataService.PersonRegisteredUsersSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstRegUser = response;

				this.lstLanguageDesc = Array.from(new Set(this.lstRegUser.map((item: any) => item.LanguageDesc))).sort();
				this.lstRegPersonActiveDesc = Array.from(new Set(this.lstRegUser.map((item: any) => item.RegPersonActiveDesc))).sort();

				this.LoadingRegUser = false;
			},
			(error) => {
				this.LoadingRegUser = false;
			}
		);
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////

	onGenerate() {
		this.ErrorMessage = "";
		if (this.SelectedPerson == undefined || this.SelectedPerson.PersonID == undefined || this.SelectedPerson.PersonID <= 0) {
			this.ErrorMessage = "Select Staff";
			return;
		}

		this.loadQRCode();
	}

	onPrint() {
		this.ErrorMessage = "";
		if (this.SelectedPerson == undefined || this.SelectedPerson.PersonID == undefined || this.SelectedPerson.PersonID <= 0) {
			this.ErrorMessage = "Select Staff";
			return;
		}

		this.Proccessing = true;

		var parms: PAQRCodeSelectRequest = {
			AppTypeID: 3, //Staff App
			PersonID: this.SelectedPerson.PersonID,
			Email: this.Email,
			EmailLocked: this.LockEmail,
			UsePrimaryDomain: this.SyncWithCAASS,
		};

		var result = this.dataService.PortalAppQRCodePrint(parms);
		result.subscribe(
			(response: any) => {
				var PdfB64 = response.str;

				console.log(this.SelectedPerson);

				var a = document.createElement("a"); //Create <a>
				var FileName = this.SelectedPerson.FirstName + "_" + this.SelectedPerson.LastName;
				a.href = PdfB64;
				a.download = FileName + ".pdf";
				a.click(); //Downloaded file

				this.Proccessing = false;
			},
			(error) => {
				this.Proccessing = false;
			}
		);
	}

	onEmail() {
		this.ErrorMessage = "";
		if (this.SelectedPerson == undefined || this.SelectedPerson.PersonID == undefined || this.SelectedPerson.PersonID <= 0) {
			this.ErrorMessage = "Select Staff";
			return;
		}
		if (this.Email == undefined || this.Email == "") {
			this.ErrorMessage = "Enter Staff's Email to send them the QR code";
			return;
		}

		this.Proccessing = true;

		var parms: PAQRCodeSelectRequest = {
			AppTypeID: 3, //Staff App
			PersonID: this.SelectedPerson.PersonID,
			Email: this.Email,
			EmailLocked: this.LockEmail,
			UsePrimaryDomain: this.SyncWithCAASS,
		};

		var result = this.dataService.PortalAppQRCodeEmail(parms);
		result.subscribe(
			(response: any) => {
				this.Proccessing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "staffportal",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Email was sent successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "staffportal",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Send the Email: " + response.Message,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Proccessing = false;
			}
		);
	}

	onRefresh() {
		this.loadRegisteredUsers();
	}

	onUpdateRegPerson(RegUser: any, ChangeTo: number) {
		var parms: RegPersonToggleRequest = {
			RegUserID: RegUser.RegUserID,
			UserID_Email: RegUser.UserID_Email,
			PersonID: this.SelectedPerson.PersonID,
			Active: ChangeTo,
		};

		this.Proccessing = true;

		var result = this.dataService.RegPersonToggle(parms);
		result.subscribe(
			(response: any) => {
				this.Proccessing = false;

				var Msg: string = "";

				if (response.Success == true) {
					if (ChangeTo == 0) {
						Msg = "Access was removed from " + String(RegUser.FirstName + " " + RegUser.LastName).trim() + " successfully. ";
						Msg += "Note: Any QR codes that were emailed to that user have been deactivated.";
					} else {
						Msg = "Access was re-enabled for " + String(RegUser.FirstName + " " + RegUser.LastName).trim() + ". ";
						Msg += "Note: They won't have to re-register and will be able to see their data next time they log in to the portal app.";
					}

					this.confirmationService.confirm({
						key: "staffportal",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: Msg,
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadRegisteredUsers();
						},
					});
				} else {
					if (ChangeTo == 0) {
						Msg = "Unable to remove access: ";
					} else {
						Msg = "Unable to re-enable access: ";
					}

					this.confirmationService.confirm({
						key: "staffportal",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: Msg + response.Message,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Proccessing = false;
			}
		);
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////

	onSyncWithCaassChange(val) {
		this.SyncWithCAASS = val;

		if (this.SyncWithCAASS == true) {
			this.LockEmail = true;
		} else {
			this.LockEmail = false;
		}
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////

	IsLoading() {
		return this.QRLoading == true || this.EmailLoading == true || this.Proccessing == true;
	}

	//////////////////////////////////////////////////////////
}
